import { render } from "./Beuty.vue?vue&type=template&id=8ca67576"
import script from "./Beuty.vue?vue&type=script&lang=js"
export * from "./Beuty.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__